import type { TFunction } from 'i18next';
import posthog from 'posthog-js';

import { toast } from '@feathr/components';
import { findRachisError } from '@feathr/rachis';

/** `meta.code` the backend sends when Google's shared daily API limit is reached. */
export const GOOGLE_ADS_QUOTA_ERROR_CODE = 'google_ads_quota_exhausted';

export const GOOGLE_ADS_QUOTA_TOAST_ID = 'google-ads-quota-exhausted';

export function isGoogleAdsQuotaExhaustedError(error: unknown): boolean {
  return !!findRachisError(error, (entry) => entry.meta?.code === GOOGLE_ADS_QUOTA_ERROR_CODE);
}

/** What caused the toast: a page loading, or the Google Ads action that failed on the limit. */
export type TGoogleAdsQuotaToastTrigger =
  | 'page_load'
  | 'publish'
  | 'keyword_ideas'
  | 'location_search'
  | 'account_connect';

/** Shows the persistent limit-reached error toast. A fixed id keeps repeats from stacking. */
export function showGoogleAdsQuotaToast(t: TFunction, trigger: TGoogleAdsQuotaToastTrigger): void {
  posthog.capture('google_ads_quota_toast_shown', { trigger });
  toast(
    {
      title: t('Google Ads is temporarily unavailable'),
      description: t(
        "Google limits daily Google Ads activity across all Feathr accounts, and today's limit has been reached. This isn't a problem with your account. Please check back after 7 AM ET.",
      ),
    },
    { type: 'error', toastId: GOOGLE_ADS_QUOTA_TOAST_ID },
  );
}
